import { STATUS } from '@features/General'
import { createSlice } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IGetPropertyUploadURLState extends ISagaCb {
    status: string
    data: null
    errors: any
}

const initialState: IGetPropertyUploadURLState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const getPropertyUploadURL = createSlice({
    name: 'property/get-upload-URL',
    initialState,
    reducers: {
        onRequest(state, action) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const getPropertyUploadURLActions = getPropertyUploadURL.actions
export default getPropertyUploadURL.reducer
